import {useEffect,} from 'react';

import {useMeters} from '../hooks/useMeters.ts';
import {Meter} from '../types';
import {FieldProps} from 'formik';
import {useAuth} from "../../../hooks/useAuth.ts";
import {FormikGenericCombobox} from "@flexinet/ui-components";
import {Alert, Anchor, Stack, TextInputProps} from "@mantine/core";
import {AiOutlineWarning} from "react-icons/ai";
import {Link} from "react-router-dom";

export const MetersAutocomplete = (props: FieldProps & TextInputProps) => {

    const {user} = useAuth()

    if (!user) {
        throw new Error('user is required parameter')
    }

    const {
        items: records,
        loading,
        fetchRecords
    } = useMeters();


    useEffect(() => {
        fetchRecords();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const noMeters = !loading && (!records || records.length === 0);

    return (
        <Stack gap='xs'>
            <FormikGenericCombobox
                records={records || []}
                valueFieldName={'id'}
                renderOption={(record: Meter) => `${record.name}`}
                getSelectedOption={(record: Meter) => `${record.name}`}
                isLoading={loading}
                {...props}
            />
            {noMeters && (
                <Alert
                    icon={<AiOutlineWarning/>}
                    color='yellow'
                    variant='light'
                    title='No meters available'
                >
                    A meter must exist before a metering record can be created.{' '}
                    <Anchor component={Link} to='/meters'>
                        Create a meter
                    </Anchor>
                    {' '}first.
                </Alert>
            )}
        </Stack>
    );
};
